'use strict';

/**
 * Helper to create a simple parameter setter convenience method
 *
 * @module util/parameter-setter
 * @param {String} param The string key of the parameter this method will set
 * @returns {Function} A setter method that can be assigned to a request instance
 */
module.exports = function( param ) {
	/**
	 * A setter for a specific parameter
	 *
	 * @chainable
	 * @param {*} val The value to set for the the parameter
	 * @returns The request instance on which this method was called (for chaining)
	 */
	return function( val ) {
		/* jshint validthis:true */
		return this.param( param, val );
	};
};



//////////////////
// WEBPACK FOOTER
// ./~/wpapi/lib/util/parameter-setter.js
// module id = 156
// module chunks = 0